/* Verona Tempo r12: vt-r12-shop. See REVAMP-LOG.md "Round 12". */
/**
 * Round 12 – shopping helpers. Deferred on every page (layout/theme.liquid), after vt-theme.js (window.vtCore).
 * Every part has its own switch in Theme settings > Verona Tempo > "Round 12 – shopping helpers"; a ticked switch puts
 * a class on <html> (snippets/vt-r12-flags.liquid). Texts: window.vtConfig.r12shop (snippets/vt-cart-config.liquid).
 *  U1  vt-r12s-outfit    "Complete the look": separate Colour + Size lists per item (the original list stays, hidden)
 *  U3  vt-r12s-photo     product photos keep their position (3rd photo → 3rd photo) when she changes colour
 *  U4  vt-r12s-notify    "Size not available?" next to the sizes → the "Notify me" form for a sold-out size
 *  U5  vt-r12s-filters   collections remember the last filters of the visit → small "Restore filters" button
 *  U6  vt-r12s-best      search panel: best sellers (collection best-sellers) before she types, fetched once per visit
 *  U7  vt-r12s-continue  "Continue shopping" (bag drawer + bag page) → last collection, same place (vt-collection.js)
 *  U8  vt-r12s-wcolour   the product-page heart saves the chosen colour; the wishlist page shows that colour's photo
 *  U9  vt-r12s-wsizes    wishlist page: sizes still in stock as small chips
 *  U10 vt-r12s-csold     colour dots crossed out when every size of that colour is sold out (+ screen-reader label)
 *  D3  vt-r12s-added     "Added to your bag" photo / name / size / price at the top of the bag after adding
 *  D8  vt-r12s-sheet     size guide = full-screen sheet on phones (title + close always at the top, page locked)
 *  T1  <vt-r12-defer>    product page "Pairs well with" is fetched when it comes near (sections/main-product.liquid)
 * U2 (slim free-delivery line) and D4 (bag controls) are CSS only: assets/vt-r12-shop.css.
 */
(function () {
  'use strict';

  var core = window.vtCore;
  if (!core) return;
  var C = (window.vtConfig && window.vtConfig.r12shop) || {};
  var S = C.strings || {};
  var html = document.documentElement;
  var on = function (name) { return html.classList.contains('vt-r12s-' + name); };
  var esc = core.esc;
  var tpl = core.tpl;
  var NEAR = '400px 0px';
  var COLOUR_NAMES = (C.colourNames || ['Color', 'Colour']).concat(['colour', 'color', 'اللون', 'لون'])
    .map(function (n) { return String(n).trim().toLowerCase(); });
  function isColourName(n) { return COLOUR_NAMES.indexOf(String(n || '').trim().toLowerCase()) > -1; }
  function motionOk() { return core.animationsOn ? core.animationsOn() && !core.reducedMotion() : !core.reducedMotion(); }
  function whenNear(el, fn) {
    if (!el) return;
    if (!('IntersectionObserver' in window)) { fn(); return; }
    var io = new IntersectionObserver(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      io.disconnect();
      fn();
    }, { rootMargin: NEAR });
    io.observe(el);
  }
  function uniq(list) { return list.filter(function (x, i) { return list.indexOf(x) === i; }); }

  /* product page basics */
  function pdp() {
    var form = document.querySelector('.section-main-product .js-product');
    var picker = form && form.querySelector('variant-picker');
    if (!picker) return null;
    var data = core.parseJsonEl(picker.querySelector('script[type="application/json"]'), { variants: [] });
    var sels = Array.prototype.slice.call(picker.querySelectorAll('.option-selector'));
    var ci = -1;
    var si = -1;
    sels.forEach(function (sel, i) {
      if (ci === -1 && (isColourName(sel.dataset.option) || sel.querySelector('.js-color-text'))) ci = i;
      if (si === -1 && core.isSizeOption(sel.dataset.option)) si = i;
    });
    return { form: form, picker: picker, variants: data.variants || [], sels: sels, ci: ci, si: si };
  }
  function selectedValue(sel) {
    var c = sel && sel.querySelector('input[type="radio"]:checked');
    if (c) return c.value;
    var f = sel && sel.querySelector('select');
    return f ? f.value : null;
  }

  /* ================================================================ U1: outfit colour + size lists */
  function enhanceOutfitSelect(orig) {
    if (orig.vtR12) return;
    var names = String(orig.dataset.vtOptNames || '').split('|');
    var si = -1;
    names.forEach(function (n, i) { if (si === -1 && core.isSizeOption(n)) si = i; });
    if (si === -1) return; // bags and single-option products keep their one list
    orig.vtR12 = true;
    var ci = names.length > 1 ? (si === 0 ? 1 : 0) : -1;
    var opts = Array.prototype.slice.call(orig.options).filter(function (o) { return o.dataset.opts; }).map(function (o) {
      return { id: o.value, vals: o.dataset.opts.split('|'), ok: !!o.value && !o.disabled };
    });
    var colours = ci > -1 ? uniq(opts.map(function (o) { return o.vals[ci]; })) : [];
    var sizes = uniq(opts.map(function (o) { return o.vals[si]; }));
    var item = orig.closest('[data-vt-outfit-item]');
    var title = item ? item.dataset.title || '' : '';
    var box = document.createElement('div');
    box.className = 'vt-r12-osel';
    var uid = orig.id + '-r12';
    var cSel = null;
    if (colours.length > 1) {
      box.insertAdjacentHTML('beforeend', '<label class="visually-hidden" for="' + esc(uid) + '-c">' + esc(S.colour) + ': ' + esc(title) + '</label>' +
        '<select class="vt-outfit__select vt-r12-osel__c" id="' + esc(uid) + '-c">' + colours.map(function (c) {
          return '<option value="' + esc(c) + '">' + esc(c) + '</option>';
        }).join('') + '</select>');
      cSel = box.querySelector('.vt-r12-osel__c');
    }
    box.insertAdjacentHTML('beforeend', '<label class="visually-hidden" for="' + esc(uid) + '-s">' + esc(S.size) + ': ' + esc(title) + '</label>' +
      '<select class="vt-outfit__select vt-r12-osel__s" id="' + esc(uid) + '-s"></select>');
    var sSel = box.querySelector('.vt-r12-osel__s');
    var colourNow = function () { return cSel ? cSel.value : (colours[0] || null); };
    var match = function (c, s) {
      return opts.filter(function (o) { return o.vals[si] === s && (ci === -1 || !c || o.vals[ci] === c); })[0] || null;
    };
    var fillSizes = function (keep) {
      var c = colourNow();
      var h = '<option value="">' + esc(S.chooseSize) + '</option>';
      sizes.forEach(function (s) {
        var m = match(c, s);
        if (!m) return;
        h += m.ok ? '<option value="' + esc(s) + '">' + esc(s) + '</option>'
          : '<option value="" disabled>' + esc(s) + ' — ' + esc(S.soldOut) + '</option>';
      });
      sSel.innerHTML = h;
      var still = keep && match(c, keep);
      sSel.value = still && still.ok ? keep : '';
    };
    var push = function () {
      var m = sSel.value ? match(colourNow(), sSel.value) : null;
      var want = m && m.ok ? m.id : '';
      if (orig.value === want) return;
      if (!want && !orig.querySelector('option[value=""]:not([disabled])')) {
        // the list had no empty choice (pre-chosen): add one so "no size yet" can be said
        var o = document.createElement('option');
        o.value = '';
        o.textContent = S.chooseSize || '';
        orig.insertBefore(o, orig.firstChild);
      }
      orig.value = want;
      orig.dispatchEvent(new Event('change', { bubbles: true }));
    };
    var pull = function () {
      var o = orig.options[orig.selectedIndex];
      var vals = o && o.value && o.dataset.opts ? o.dataset.opts.split('|') : null;
      if (cSel && vals) cSel.value = vals[ci];
      fillSizes(vals ? vals[si] : sSel.value);
    };
    if (cSel) {
      // first colour with something in stock, unless one is already chosen
      var firstOk = opts.filter(function (o) { return o.ok; })[0];
      if (firstOk) cSel.value = firstOk.vals[ci];
      cSel.addEventListener('change', function (e) { e.stopPropagation(); fillSizes(sSel.value); push(); });
    }
    sSel.addEventListener('change', function (e) { e.stopPropagation(); push(); });
    orig.insertAdjacentElement('afterend', box);
    orig.classList.add('vt-r12-osel__orig');
    orig.setAttribute('aria-hidden', 'true');
    orig.tabIndex = -1;
    var lab = orig.id ? document.querySelector('label[for="' + orig.id + '"]') : null;
    if (lab) lab.hidden = true;
    pull();
    orig.vtR12Pull = pull;
  }
  function initOutfitSizes() {
    if (!on('outfit')) return;
    document.querySelectorAll('vt-outfit').forEach(function (card) {
      whenNear(card, function () {
        card.querySelectorAll('select[data-vt-outfit-variant][data-vt-opt-names]').forEach(enhanceOutfitSelect);
        // the main item follows the product page's own picker (vt-theme.js sets its value without an event)
        var product = card.closest('.js-product');
        if (product) {
          product.addEventListener('on:variant:change', function () {
            window.setTimeout(function () {
              card.querySelectorAll('select[data-vt-outfit-variant]').forEach(function (s) { if (s.vtR12Pull) s.vtR12Pull(); });
            }, 0);
          });
        }
      });
    });
  }

  /* ================================================================ T1: rows fetched only when near */
  if (!customElements.get('vt-r12-defer')) {
    customElements.define('vt-r12-defer', class extends HTMLElement {
      connectedCallback() {
        if (this.vtBound) return;
        this.vtBound = true;
        var product = this.closest('.js-product');
        // "Complete the look" from the product's own list replaces this row (its CSS hides it): nothing to fetch
        if (product && product.querySelector('.vt-ctl vt-outfit')) return;
        whenNear(this, () => {
          var t = this.querySelector('template');
          if (t) { this.appendChild(t.content.cloneNode(true)); t.remove(); }
        });
      }
    });
  }

  /* ================================================================ U3: same photo position after a colour change */
  function initPhotoKeep() {
    if (!on('photo')) return;
    var P = pdp();
    if (!P || P.ci === -1) return;
    var gallery = document.querySelector('.section-main-product media-gallery');
    var cs = gallery && gallery.querySelector('.main-image carousel-slider');
    if (!cs) return;
    var slidesAll = function () { return Array.prototype.slice.call(cs.querySelectorAll('.slider__item')); };
    var slidesVisible = function () { return slidesAll().filter(function (el) { return !el.hidden; }); };
    var activeOf = function (list) {
      var a = cs.querySelector('.slider__item.is-active');
      return a ? list.indexOf(a) : -1;
    };
    // where each colour's photos start in the gallery (from the colour's variant photos), and where they end
    var ranges = null;
    var rangeOf = function (colour) {
      if (!ranges) {
        var ids = slidesAll().map(function (el) { return String(el.dataset.mediaId); });
        var starts = {};
        P.variants.forEach(function (v) {
          var c = v.options && v.options[P.ci];
          var i = v.featured_media ? ids.indexOf(String(v.featured_media.id)) : -1;
          if (c && i > -1 && (starts[c] === undefined || i < starts[c])) starts[c] = i;
        });
        var sorted = Object.keys(starts).map(function (k) { return starts[k]; }).sort(function (a, b) { return a - b; });
        ranges = {};
        Object.keys(starts).forEach(function (k) {
          var s = starts[k];
          var next = sorted.filter(function (x) { return x > s; })[0];
          ranges[k] = [s, next === undefined ? ids.length : next];
        });
      }
      return ranges[colour] || null;
    };
    var prev = selectedValue(P.sels[P.ci]);
    // Symmetry's gallery moves to the new colour's photo before 'on:variant:change' reaches us, so the photo she
    // was looking at is noted when the choice starts (capture phase of the picker's own 'change')
    var snap = { all: -1, vis: -1 };
    P.form.addEventListener('change', function (evt) {
      if (!evt.target || !evt.target.closest || !evt.target.closest('variant-picker')) return;
      snap = { all: activeOf(slidesAll()), vis: activeOf(slidesVisible()) };
    }, true);
    P.form.addEventListener('on:variant:change', function (evt) {
      var d = evt.detail || {};
      var opts = d.selectedOptions || (d.variant && d.variant.options);
      var colour = opts ? opts[P.ci] : null;
      var from = prev;
      if (colour) prev = colour;
      if (!colour || !from || colour === from || !cs.offsetParent) return;
      var grouped = !!gallery.mediaGroupingEnabled;
      var target = null;
      if (grouped) {
        var k = snap.vis;
        if (k < 1) return;
        window.setTimeout(function () {
          var list = slidesVisible();
          if (k < list.length) gallery.setActiveMedia(list[k].dataset.mediaId, true);
        }, 60);
        return;
      }
      var all = slidesAll();
      var a = snap.all;
      var r0 = rangeOf(from);
      var r1 = rangeOf(colour);
      if (!r0 || !r1 || a < r0[0] || a >= r0[1]) return;
      var offset = a - r0[0];
      if (offset < 1 || r1[0] + offset >= r1[1]) return; // same first photo / not enough photos: Symmetry's first photo
      target = all[r1[0] + offset];
      window.setTimeout(function () {
        if (target && typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(target.dataset.mediaId, true);
      }, 60);
    });
  }

  /* ================================================================ U10: sold-out colours */
  function initColourSoldOut() {
    if (!on('csold')) return;
    var P = pdp();
    if (!P || P.ci === -1 || P.sels.length < 2) return;
    var fs = P.sels[P.ci];
    var run = function () {
      fs.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var value = input.value;
        var any = P.variants.some(function (v) { return v.available && v.options[P.ci] === value; });
        var label = input.nextElementSibling;
        if (label && label.tagName === 'LABEL') label.classList.toggle('vt-r12-cout', !any);
        input.setAttribute('aria-label', tpl(any ? S.inStock : S.colourOut, { colour: value }));
      });
    };
    run();
    P.form.addEventListener('on:variant:change', function () { window.setTimeout(run, 0); });
  }

  /* ================================================================ U4: "Size not available?" → notify me */
  function initSizeNotify() {
    if (!on('notify')) return;
    var P = pdp();
    if (!P || P.si === -1) return;
    var bis = P.form.querySelector('[data-vt-bis]') || document.querySelector('.section-main-product [data-vt-bis]');
    var panel = bis && bis.querySelector('[data-vt-bis-panel]');
    var tags = bis && bis.querySelector('[data-vt-bis-tags]');
    if (!panel || !tags) return;
    var fs = P.sels[P.si];
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'link vt-r12-sna';
    btn.textContent = S.sizeNA || '';
    var holder = fs.querySelector('.vt-size-links');
    if (holder) holder.appendChild(btn);
    else (fs.querySelector('.option-selector__btns') || fs.lastElementChild).insertAdjacentElement('afterend', btn);

    var soldOutHere = function () {
      var colour = P.ci > -1 ? selectedValue(P.sels[P.ci]) : null;
      return P.variants.filter(function (v) { return !v.available && (P.ci === -1 || v.options[P.ci] === colour); });
    };
    var row = null;
    var field = null;
    var setTag = function () {
      if (field && field.value) tags.value = bis.dataset.baseTags + ',bis-v-' + field.value;
    };
    var build = function () {
      var list = soldOutHere();
      if (!row) {
        row = document.createElement('div');
        row.className = 'vt-r12-bis-size';
        var id = (bis.dataset.formId || 'vt-bis') + '-r12size';
        row.innerHTML = '<label for="' + esc(id) + '">' + esc(S.whichSize) + '</label><select id="' + esc(id) + '"></select>';
        field = row.querySelector('select');
        field.addEventListener('change', setTag);
        var anchor = panel.querySelector('.vt-bis__row');
        if (anchor) anchor.insertAdjacentElement('beforebegin', row); else panel.appendChild(row);
      }
      var chosen = selectedValue(fs);
      field.innerHTML = list.map(function (v) {
        return '<option value="' + v.id + '"' + (v.options[P.si] === chosen ? ' selected' : '') + '>' + esc(v.options[P.si]) + '</option>';
      }).join('');
      row.hidden = !list.length;
      setTag();
    };
    var sync = function () {
      btn.hidden = !soldOutHere().length;
      if (row && !row.hidden) build();
    };
    btn.addEventListener('click', function () {
      build();
      panel.hidden = false;
      var success = bis.querySelector('[data-vt-bis-success]');
      if (success) success.remove();
      try { panel.scrollIntoView({ block: 'center', behavior: motionOk() ? 'smooth' : 'auto' }); } catch (e) { panel.scrollIntoView(); }
      window.setTimeout(function () { if (field) field.focus({ preventScroll: true }); }, motionOk() ? 350 : 0);
    });
    P.form.addEventListener('on:variant:change', function (evt) {
      // vt-back-in-stock sets the tags to the chosen variant; the size list follows the new colour
      window.setTimeout(function () {
        sync();
        var v = evt.detail && evt.detail.variant;
        if (field && v && !v.available && field.querySelector('option[value="' + v.id + '"]')) { field.value = String(v.id); setTag(); }
      }, 0);
    });
    sync();
  }

  /* ================================================================ U5: "Restore filters" on collections */
  var FKEY = 'vt-r12-filters';
  function filterPart(search) {
    var p = new URLSearchParams(search || '');
    var out = new URLSearchParams();
    var n = 0;
    p.forEach(function (v, k) {
      if (/^filter\./.test(k) || k === 'sort_by') { out.append(k, v); if (/^filter\./.test(k)) n += 1; }
    });
    return { q: out.toString(), n: n };
  }
  function initFilterMemory() {
    if (!on('filters') || !document.body.classList.contains('template-collection')) return;
    var fc = document.querySelector('filter-container');
    if (!fc) return;
    var path = window.location.pathname;
    var read = function () { try { return JSON.parse(core.storageGet('sessionStorage', FKEY) || '{}') || {}; } catch (e) { return {}; } };
    var write = function (m) { core.storageSet('sessionStorage', FKEY, JSON.stringify(m)); };
    var chip = null;
    var dropChip = function () { if (chip) { chip.remove(); chip = null; } };
    var cur = filterPart(window.location.search);
    var map = read();
    if (cur.n) {
      map[path] = cur.q;
      write(map);
    } else if (map[path]) {
      var saved = filterPart('?' + map[path]);
      if (saved.n) {
        chip = document.createElement('div');
        chip.className = 'vt-r12-restore';
        chip.innerHTML = '<a class="vt-r12-restore__btn" href="' + esc(path + '?' + saved.q) + '" aria-label="' + esc(S.restoreLabel) + ' (' + saved.n + ')">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 6h16M7 12h10M10 18h4"/></svg>' +
          '<span>' + esc(tpl(S.restore, { count: saved.n })) + '</span></a>';
        var bar = fc.querySelector('.utility-bar') || document.querySelector('.utility-bar');
        if (bar && bar.parentNode) bar.insertAdjacentElement('afterend', chip);
        else fc.insertAdjacentElement('beforebegin', chip);
      }
    }
    // Symmetry changes the address when she filters (history.pushState): remember it, or forget it when she clears
    var last = window.location.search;
    var check = function () {
      if (window.location.search === last) return;
      last = window.location.search;
      var now = filterPart(last);
      var m = read();
      if (now.n) { m[path] = now.q; dropChip(); } else if (!chip) { delete m[path]; }
      write(m);
    };
    if (core.onListingRefresh) core.onListingRefresh(check);
    window.addEventListener('popstate', check);
    window.addEventListener('pagehide', check);
  }

  /* ================================================================ U6: best sellers in the search panel */
  function initSearchBest() {
    if (!on('best') || !html.classList.contains('vt-r11-search')) return;
    var panel = document.querySelector('.section-header main-search');
    if (!panel) return;
    var key = 'vt-r12-best-' + (html.lang || 'x');
    var done = false;
    var draw = function (items) {
      var start = panel.querySelector('.vt-r11-start');
      if (!start || !items.length || start.querySelector('.vt-r12-best')) return;
      var box = document.createElement('div');
      box.className = 'vt-r12-best';
      box.innerHTML = '<p class="vt-r11-sugg__title" id="vt-r12-best-title">' + esc(S.best) + '</p>' +
        '<ul class="vt-r12-best__list" role="list" aria-labelledby="vt-r12-best-title">' + items.map(function (p) {
          var sale = p.compare_at_price > p.price;
          return '<li><a class="vt-r12-best__item" href="' + esc(core.route('products/' + p.handle)) + '">' +
            '<span class="vt-r12-best__media">' + (p.featured_image ? '<img src="' + esc(core.imageUrl(p.featured_image, 300)) + '" srcset="' +
              esc(core.imageUrl(p.featured_image, 200)) + ' 200w, ' + esc(core.imageUrl(p.featured_image, 300)) + ' 300w, ' + esc(core.imageUrl(p.featured_image, 400)) + ' 400w" sizes="(min-width: 768px) 150px, 30vw" alt="" loading="lazy" width="300" height="300">' : '') + '</span>' +
            '<span class="vt-r12-best__name">' + esc(p.title) + '</span>' +
            '<span class="vt-r12-best__price">' + (sale ? '<span class="vt-r12-best__now">' + esc(core.formatMoney(p.price)) + '</span> <s>' + esc(core.formatMoney(p.compare_at_price)) + '</s>' : esc(core.formatMoney(p.price))) + '</span>' +
            '</a></li>';
        }).join('') + '</ul>';
      start.appendChild(box);
    };
    var load = function () {
      if (done) return;
      done = true;
      var cached = null;
      try { cached = JSON.parse(core.storageGet('sessionStorage', key) || 'null'); } catch (e) { cached = null; }
      if (cached && Array.isArray(cached.items) && Date.now() - (cached.t || 0) < 3 * 3600000) { draw(cached.items); return; }
      fetch(core.route('collections/' + encodeURIComponent(C.bestHandle || 'best-sellers') + '/products.json?limit=12'), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) {
          var items = (d.products || []).map(core.normaliseCollectionProduct).filter(function (p) { return p.available; }).slice(0, 6);
          if (items.length < 4) items = items.slice(0, items.length); // fewer than 4 in stock: show what there is
          core.storageSet('sessionStorage', key, JSON.stringify({ t: Date.now(), items: items }));
          draw(items);
        })
        .catch(function () { done = false; });
    };
    var check = function () { if (document.body.classList.contains('show-search')) load(); };
    new MutationObserver(check).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    check();
  }

  /* ================================================================ U7: "Continue shopping" → last collection */
  function lastListing() {
    var st = null;
    try { st = JSON.parse(core.storageGet('sessionStorage', 'vt-listing') || 'null'); } catch (e) { st = null; }
    if (st && typeof st.url === 'string' && /^\/(?!\/)/.test(st.url) && /\/collections\/[^/?#]+/.test(st.url)) return st.url;
    var lc = null;
    try { lc = JSON.parse(core.storageGet('localStorage', 'vt-last-collection') || 'null'); } catch (e) { lc = null; }
    if (lc && typeof lc.path === 'string' && /^\/(?!\/)/.test(lc.path) && core.storageGet('sessionStorage', 'vt-coll-this-visit')) return lc.path;
    return '';
  }
  function initContinue() {
    if (!on('continue')) return;
    var here = function () { return window.location.pathname + window.location.search; };
    var follow = function (evt, a, drawer) {
      if (evt.defaultPrevented || evt.button || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey) return;
      if (a.getAttribute('href') === here() && drawer && typeof drawer.close === 'function') {
        evt.preventDefault();
        drawer.close();
        return;
      }
      core.storageSet('sessionStorage', 'vt-r12-continue', '1');
    };
    // bag page: Symmetry's own link (Theme editor > Bag page > "Show continue shopping link")
    var url = lastListing();
    document.querySelectorAll('.template-cart a.continue-shopping').forEach(function (a) {
      if (!url) return;
      a.setAttribute('href', url);
      a.addEventListener('click', function (evt) { follow(evt, a, null); });
    });
    // bag drawer: a quiet link under the checkout button
    var drawer = document.querySelector('cart-drawer.js-cart-drawer');
    if (!drawer) return;
    var place = function () {
      var target = lastListing();
      var box = drawer.querySelector('.checkout-buttons');
      var link = drawer.querySelector('.vt-r12-cont');
      if (!target || !box) { if (link) link.remove(); return; }
      if (!link) {
        link = document.createElement('a');
        link.className = 'vt-r12-cont';
        link.textContent = S.cont || '';
        link.addEventListener('click', function (evt) { follow(evt, link, drawer); });
      }
      link.setAttribute('href', target);
      if (link.previousElementSibling !== box) box.insertAdjacentElement('afterend', link);
    };
    drawer.addEventListener('on:cart-drawer:before-open', place);
    // the bag's content is re-drawn after each change (Symmetry): put the link back when it goes missing
    var t = null;
    new MutationObserver(function () {
      window.clearTimeout(t);
      t = window.setTimeout(function () { if (!drawer.querySelector('.vt-r12-cont') || drawer.hasAttribute('open')) place(); }, 80);
    }).observe(drawer, { childList: true, subtree: true });
    place();
  }

  /* ================================================================ U8 + U9: wishlist colour + sizes */
  var WKEY = 'vt-r12-wl-variants';
  function readW() { try { var m = JSON.parse(core.storageGet('localStorage', WKEY) || '{}'); return m && typeof m === 'object' ? m : {}; } catch (e) { return {}; } }
  function writeW(m) { core.storageSet('localStorage', WKEY, JSON.stringify(m)); }
  function initWishColour() {
    if (!on('wcolour')) return;
    document.addEventListener('click', function (evt) {
      var btn = evt.target.closest && evt.target.closest('.section-main-product [data-vt-wishlist-toggle]');
      if (!btn || btn.closest('.quickbuy-container')) return;
      var handle = btn.dataset.handle;
      var form = btn.closest('.section-main-product');
      var idEl = form && form.querySelector('.js-product [name="id"]');
      var id = idEl ? parseInt(idEl.value, 10) : 0;
      // vt-theme.js has already toggled the list (its listener comes first)
      window.setTimeout(function () {
        var m = readW();
        if (core.wishlist.has(handle) && id) m[handle] = id; else delete m[handle];
        writeW(m);
      }, 0);
    }, true);
  }
  function dressWishCard(li, p, variants) {
    if (li.vtR12) return;
    li.vtR12 = true;
    var names = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    var si = -1;
    var ci = -1;
    names.forEach(function (n, i) {
      if (si === -1 && core.isSizeOption(n)) si = i;
      else if (ci === -1 && isColourName(n)) ci = i;
    });
    if (ci === -1 && si > -1 && names.length === 2) ci = si === 0 ? 1 : 0;
    var saved = on('wcolour') ? variants[p.handle] : null;
    var v = saved ? (p.variants || []).filter(function (x) { return x.id === saved; })[0] : null;
    var colour = v && ci > -1 ? v.options[ci] : null;
    if (v) {
      var img = li.querySelector('.vt-card__media img');
      var src = v.featured_image && v.featured_image.src;
      if (img && src) {
        img.src = core.imageUrl(src, 480);
        img.srcset = core.imageUrl(src, 300) + ' 300w, ' + core.imageUrl(src, 480) + ' 480w, ' + core.imageUrl(src, 720) + ' 720w';
      }
      var link = li.querySelector('.vt-card__link');
      if (link) link.setAttribute('href', core.route('products/' + p.handle) + '?variant=' + v.id);
      var title = li.querySelector('.vt-card__title');
      if (colour && title && ci > -1) title.insertAdjacentHTML('afterend', '<span class="vt-r12-wcol">' + esc(colour) + '</span>');
    }
    if (on('wsizes') && si > -1 && p.available) {
      var order = [];
      (p.variants || []).forEach(function (x) { if (order.indexOf(x.options[si]) === -1) order.push(x.options[si]); });
      var ok = order.filter(function (s) {
        return (p.variants || []).some(function (x) { return x.available && x.options[si] === s && (!colour || x.options[ci] === colour); });
      });
      if (ok.length) {
        li.insertAdjacentHTML('beforeend', '<p class="vt-r12-wsizes" role="note" aria-label="' + esc(tpl(S.wishSizesLabel, { sizes: ok.join(', ') })) + '">' +
          '<span class="vt-r12-wsizes__lbl" aria-hidden="true">' + esc(S.wishSizes) + '</span>' +
          ok.map(function (s) { return '<span class="vt-r12-wsizes__chip" aria-hidden="true">' + esc(s) + '</span>'; }).join('') + '</p>');
      }
    }
  }
  function initWishPage() {
    if (!on('wcolour') && !on('wsizes')) return;
    var grid = document.querySelector('vt-wishlist-grid');
    var list = grid && grid.querySelector('[data-vt-list]');
    if (!list) return;
    var run = function () {
      var variants = readW();
      list.querySelectorAll('li.vt-card[data-handle]').forEach(function (li) {
        if (li.vtR12) return;
        core.fetchProduct(li.dataset.handle).then(function (p) { if (p && li.isConnected) dressWishCard(li, p, variants); });
      });
    };
    new MutationObserver(run).observe(list, { childList: true });
    run();
    // forget the colour of items taken off the wishlist
    document.addEventListener('vt:wishlist:change', function () {
      var m = readW();
      var keep = core.wishlist.get();
      var changed = false;
      Object.keys(m).forEach(function (h) { if (keep.indexOf(h) === -1) { delete m[h]; changed = true; } });
      if (changed) writeW(m);
    });
  }

  /* ================================================================ D3: "Added to your bag" preview */
  function initAddedPreview() {
    if (!on('added')) return;
    var drawer = document.querySelector('cart-drawer.js-cart-drawer');
    if (!drawer || document.body.classList.contains('template-cart')) return;
    var pending = null;
    var remove = function () { drawer.querySelectorAll('.vt-r12-added').forEach(function (el) { el.remove(); }); };
    document.addEventListener('on:cart:add', function (evt) {
      var id = evt.detail && evt.detail.variantId;
      if (id) pending = { id: parseInt(id, 10), t: Date.now() };
    });
    drawer.addEventListener('on:cart-drawer:before-close', function () { pending = null; window.setTimeout(remove, 400); });
    core.onCart(function (cart) {
      if (!pending || Date.now() - pending.t > 8000) return;
      var want = pending.id;
      pending = null;
      if (!drawer.hasAttribute('open')) return;
      var item = (cart.items || []).filter(function (i) { return i.variant_id === want; })[0];
      if (!item) return;
      remove();
      var opts = (item.options_with_values || []).filter(function (o) { return o.value && o.value !== 'Default Title'; })
        .map(function (o) { return o.value; }).join(' · ');
      var el = document.createElement('div');
      el.className = 'vt-r12-added' + (motionOk() ? ' vt-r12-added--in' : '');
      el.innerHTML = (item.image ? '<img class="vt-r12-added__img" src="' + esc(core.imageUrl(item.image, 160)) + '" alt="" width="56" height="56">' : '') +
        '<div class="vt-r12-added__txt"><p class="vt-r12-added__title">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.2 4.2L19 7"/></svg>' +
        esc(S.added) + '</p><p class="vt-r12-added__name">' + esc(item.product_title || item.title) + '</p>' +
        '<p class="vt-r12-added__meta">' + (opts ? '<span>' + esc(opts) + '</span>' : '') + '<span class="vt-r12-added__price">' + esc(core.formatMoney(item.final_price)) + '</span></p></div>';
      var head = drawer.querySelector('.cart-drawer__header');
      if (!head) return;
      head.insertAdjacentElement('afterend', el);
      core.announce(tpl(S.addedSay, { title: (item.product_title || item.title) + (opts ? ', ' + opts : '') }));
    });
  }

  /* ================================================================ D8: size guide sheet on phones */
  function initSizeSheet() {
    if (!on('sheet')) return;
    var mq = window.matchMedia('(max-width: 767.98px)');
    document.querySelectorAll('modal-dialog[id^="size-chart-"]').forEach(function (modal) {
      var win = modal.querySelector('.modal__window');
      if (!win || win.querySelector('.vt-r12-sheet__head')) return;
      var tid = modal.id + '-r12t';
      var head = document.createElement('div');
      head.className = 'vt-r12-sheet__head';
      head.innerHTML = '<h2 class="vt-r12-sheet__title" id="' + esc(tid) + '">' + esc(modal.getAttribute('aria-label') || S.sizeGuide) + '</h2>' +
        '<button type="button" class="vt-r12-sheet__close js-close-modal" aria-label="' + esc(S.close) + '">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
      win.insertBefore(head, win.firstChild);
      new MutationObserver(function () {
        var open = modal.hasAttribute('open');
        html.classList.toggle('vt-r12-sheet-open', open && mq.matches);
        if (open && mq.matches) {
          var body = modal.querySelector('.modal__content');
          if (body) body.scrollTop = 0;
          window.setTimeout(function () {
            var btn = head.querySelector('button');
            if (modal.hasAttribute('open') && btn && (document.activeElement === modal || !modal.contains(document.activeElement))) btn.focus();
          }, 30);
        }
      }).observe(modal, { attributes: true, attributeFilter: ['open'] });
    });
  }

  /* ------------------------------------------------------------------ boot */
  core.onReady(function () {
    var parts = [initOutfitSizes, initPhotoKeep, initColourSoldOut, initSizeNotify, initFilterMemory, initSearchBest,
      initContinue, initWishColour, initWishPage, initAddedPreview, initSizeSheet];
    parts.forEach(function (fn) { try { fn(); } catch (e) { if (window.console) console.warn('vt-r12-shop', fn.name, e); } });
  });
})();
